import { render, staticRenderFns } from "./purchaseDetail.vue?vue&type=template&id=e47ec856"
import script from "./purchaseDetail.vue?vue&type=script&lang=ts"
export * from "./purchaseDetail.vue?vue&type=script&lang=ts"
import style0 from "./purchaseDetail.vue?vue&type=style&index=0&id=e47ec856&prod&lang=stylus"
import style1 from "./purchaseDetail.vue?vue&type=style&index=1&id=e47ec856&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports